import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function RawSignalsPage() {
  const [signals, setSignals] = useState([]);

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);

        setSignals((prev) => [msg, ...prev].slice(0, 100));
      } catch {}
    };

    return () => ws.close();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#000",
      }}
    >
      <Header />

      <div
        style={{
          flex: 1,
          padding: "24px",
          maxWidth: "1200px",
          margin: "0 auto",
          color: "#fff",
        }}
      >
        <h1 style={{ marginBottom: 10 }}>🧪 Protocol Insights</h1>

        <p style={{ color: "#888", marginBottom: 20 }}>
          A high-level stream of on-chain events representing structured network telemetry and real-time interaction dynamics.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {signals.map((s, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #222",
                borderRadius: 8,
                padding: 12,
                background: "#0a0a0a",
              }}
            >
              <div style={{ color: "#0f0", fontSize: 12, marginBottom: 6 }}>
                {s.event || "NO_EVENT"}
              </div>

              <pre
                style={{
                  fontSize: 11,
                  color: "#aaa",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                }}
              >
                {JSON.stringify(s, null, 2)}
              </pre>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}